"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useEffect, useLayoutEffect, useState } from "react"
import { useSession } from "next-auth/react"
import { createClientSession } from "../lib/auth/clientSession"
import { ClientSessionContext } from "../lib/auth/ClientSessionContext"

// Share refreshes between Apollo, account fetches, and session maintenance.
export function SessionManager({ children }: { children: React.ReactNode }) {
  const { data: session, status, update } = useSession()
  const [credentials] = useState(() =>
    createClientSession(
      session,
      (payload) => update(payload),
      () => {
        // Full navigation removes the expired cookie and all client state.
        if (typeof window !== "undefined") {
          // eslint-disable-next-line @next/next/no-location-assign-relative-destination
          window.location.href = "/api/auth/server-logout"
        }
      },
    ),
  )

  useLayoutEffect(() => {
    credentials.setAuthState(session, status, update)
  }, [credentials, session, status, update])

  useEffect(() => {
    // NextAuth returns refresh failures as session data. The controller handles
    // those and coordinates proactive refresh with any requests already running.
    void credentials.getToken().catch(() => {})
  }, [credentials, session])

  return <ClientSessionContext value={credentials}>{children}</ClientSessionContext>
}
